export const LIMA = (props) => (
  <a
    aria-label="Lise Medeniyet Akademisi Website linki"
    href="https://lisemedeniyet.konya.bel.tr/WEBPortal/Anasayfa"
    target="_blank"
    rel="noreferrer"
  >
    <svg viewBox="0 0 30.17 16.84" {...props}>
      <g id="Layer_1-2" data-name="Layer 1">
        <g>
          <path
            className="cls-1"
            d="M10.24,3.7c-.22,0-.45,0-.68,0-1.89.04-3.42,1.56-3.48,3.45-.08,2.87-.09,4.49-.09,4.49l2.42-.11-.08-4.18c0-.06,0-.11,0-.16h0c.02-1.07.11-3.51,1.9-3.5"
          />
          <path
            className="cls-1"
            d="M9.73,6c1.25.05,3.18.18,5.2.53-.12-.92-.41-1.82-.87-2.64-1.11-.11-2.42-.19-3.81-.18-1.79-.01-1.88,2.43-1.9,3.5h0c.07-.69.67-1.23,1.38-1.2"
          />
          <path
            className="cls-1"
            d="M12.42,1.85c-.99-.04-1.85-.01-2.53.03-.05,0-.1,0-.16.01-.75.03-2.92.47-3.23-.89.29,1.34,1.49,2.35,2.93,2.31,2.12-.06,3.74.07,4.36.13-.38-.58-.83-1.12-1.37-1.59"
          />
          <path
            className="cls-1"
            d="M9.89,1.88c-.05,0-.11,0-.16.01.06,0,.11,0,.16-.01"
          />
          <path
            className="cls-1"
            d="M9.73,1.89c-.85.06-1.59-.6-1.61-1.46V.03c-.57-.05-1.13-.03-1.68.05,0,.04,0,.07,0,.11-.02.28,0,.56.06.82.31,1.36,2.48.91,3.23.89"
          />
          <path
            className="cls-1"
            d="M4.09.81c-.02.2-.05.44-.09.74,0,.03-.01.05-.02.07,0,.01,0,.03,0,.05-.06.42-.07,2.25-1.88,2.59,0,0,0,0,0,0,.35-.08.7-.16,1.01-.22,1.5-.31,2.61-1.59,2.7-3.12l.04-.73c-.61.14-1.21.35-1.77.63"
          />
          <path
            className="cls-1"
            d="M3.98,1.67s0-.03,0-.05c-.11.58-.54,1.04-1.12,1.17-.53.12-1.03.24-1.5.38-.13.18-.25.37-.37.57-.17.3-.32.6-.45.91.55-.15,1.06-.28,1.55-.4,0,0,0,0,0,0,1.81-.33,1.82-2.17,1.88-2.59"
          />
          <path
            className="cls-1"
            d="M2.57,4.59c-.37.08-.71.16-1.03.24,1.24-.25,1.86,1.03,1.79,2.19l-.74,6.17c.35.3.72.57,1.13.8.48.28.97.49,1.48.65.03-1.11.13-3.99.28-7.63.06-1.57-1.37-2.77-2.9-2.43"
          />
          <polygon
            className="cls-1"
            points="1.88 8.9 1.88 8.9 1.88 8.91 1.88 8.9"
          />
          <path
            className="cls-1"
            d="M1.54,4.83c-.43.11-.83.21-1.18.31-.2.59-.32,1.2-.36,1.8,1.15-.27,2.09-.44,2.69-.54.36-.06.68.25.64.61.07-1.16-.55-2.44-1.79-2.19"
          />
          <polygon
            className="cls-1"
            points="15.29 16.42 15.66 16.42 15.66 16.57 15.11 16.57 15.11 15.65 15.29 15.65 15.29 16.42"
          />
          <path
            className="cls-1"
            d="M15.8,15.9h.17v.67h-.17v-.67ZM15.8,15.61h.17v.19h-.17v-.19Z"
          />
          <path
            className="cls-1"
            d="M16.37,16.58c-.07,0-.17-.02-.23-.04l.02-.13c.06.02.13.03.2.03.07,0,.09-.02.09-.07,0-.04,0-.06-.12-.09-.16-.04-.18-.08-.18-.21s.06-.19.25-.19c.06,0,.14,0,.2.02l-.02.13c-.05-.01-.13-.02-.18-.02-.07,0-.09.02-.09.06,0,.05,0,.06.1.08.19.05.21.07.21.21,0,.13-.04.21-.24.21"
          />
          <path
            className="cls-1"
            d="M16.92,16.17h.21v-.03c0-.06-.02-.11-.1-.11s-.11.04-.11.11v.03ZM17.05,16.45c.06,0,.13-.01.2-.03l.03.13c-.08.03-.17.04-.25.04-.21,0-.28-.1-.28-.26v-.18c0-.14.06-.26.28-.26s.26.13.26.27v.14h-.37v.03c0,.08.03.11.13.11"
          />
          <polygon
            className="cls-1"
            points="18.31 16.45 18.09 16.45 17.92 15.98 17.9 16.57 17.72 16.57 17.76 15.65 17.96 15.65 18.2 16.31 18.43 15.65 18.63 15.65 18.67 16.57 18.49 16.57 18.48 15.98 18.31 16.45"
          />
          <path
            className="cls-1"
            d="M18.99,16.17h.21v-.03c0-.06-.02-.11-.1-.11s-.11.04-.11.11v.03ZM19.12,16.45c.06,0,.13-.01.2-.03l.03.13c-.08.03-.17.04-.25.04-.21,0-.28-.1-.28-.26v-.18c0-.14.06-.26.28-.26s.26.13.26.27v.14h-.37v.03c0,.08.03.11.13.11"
          />
          <path
            className="cls-1"
            d="M19.89,16.05s-.1-.02-.15-.02c-.06,0-.08.03-.08.09v.24c0,.06.02.08.08.08.05,0,.11-.03.15-.06v-.33ZM19.49,16.12c0-.15.07-.24.22-.24.06,0,.13,0,.18.02v-.28l.17-.02v.97h-.13l-.02-.06c-.06.04-.13.07-.21.07-.14,0-.21-.08-.21-.23v-.23Z"
          />
          <path
            className="cls-1"
            d="M20.39,16.17h.21v-.03c0-.06-.02-.11-.1-.11s-.11.04-.11.11v.03ZM20.52,16.45c.06,0,.13-.01.2-.03l.03.13c-.08.03-.17.04-.25.04-.21,0-.28-.1-.28-.26v-.18c0-.14.06-.26.28-.26s.26.13.26.27v.14h-.37v.03c0,.08.03.11.13.11"
          />
          <path
            className="cls-1"
            d="M21.31,16.57v-.47s-.02-.05-.05-.05c-.04,0-.12.02-.18.06v.47h-.17v-.67h.13l.02.06c.08-.04.19-.07.27-.07.11,0,.15.08.15.2v.49h-.17Z"
          />
          <path
            className="cls-1"
            d="M21.66,15.9h.17v.67h-.17v-.67ZM21.66,15.61h.17v.19h-.17v-.19Z"
          />
          <polygon
            className="cls-1"
            points="22.37 16.57 22.28 16.84 22.12 16.84 22.2 16.57 22.15 16.57 21.93 15.9 22.11 15.9 22.26 16.41 22.41 15.9 22.58 15.9 22.37 16.57"
          />
          <path
            className="cls-1"
            d="M22.81,16.17h.21v-.03c0-.06-.02-.11-.1-.11s-.11.04-.11.11v.03ZM22.94,16.45c.06,0,.13-.01.2-.03l.03.13c-.08.03-.17.04-.25.04-.21,0-.28-.1-.28-.26v-.18c0-.14.06-.26.28-.26s.26.13.26.27v.14h-.37v.03c0,.08.03.11.13.11"
          />
          <path
            className="cls-1"
            d="M23.69,16.56s-.11.03-.15.03c-.12,0-.19-.06-.19-.18v-.37h-.1v-.13h.1v-.17l.17-.02v.19h.17v.13h-.17v.35s.02.06.06.06c.02,0,.05,0,.08-.01l.02.13Z"
          />
          <path
            className="cls-1"
            d="M24.34,16.23h.25l-.13-.43-.13.43ZM24.63,16.38h-.34l-.06.19h-.18l.29-.92h.24l.29.92h-.18l-.06-.19Z"
          />
          <path
            className="cls-1"
            d="M25.58,15.9l-.2.33.21.34h-.18l-.2-.34.19-.33h.19ZM25,16.57v-.94l.17-.02v.97h-.17Z"
          />
          <path
            className="cls-1"
            d="M26.03,16.32h-.12c-.05,0-.07.02-.07.07,0,.05.02.07.07.07.05,0,.09-.02.13-.03v-.1ZM26.2,16.57h-.14v-.05c-.07.04-.14.06-.21.06-.12,0-.18-.08-.18-.2,0-.14.06-.19.2-.19h.16v-.07c0-.07-.02-.1-.13-.1-.06,0-.13,0-.19.02l-.02-.13c.06-.02.16-.03.23-.03.21,0,.27.07.27.24v.44Z"
          />
          <path
            className="cls-1"
            d="M26.75,16.05s-.1-.02-.15-.02c-.06,0-.08.03-.08.09v.24c0,.06.02.08.08.08.06,0,.12-.03.15-.06v-.33ZM26.35,16.12c0-.15.07-.24.22-.24.06,0,.13,0,.18.02v-.28l.17-.02v.97h-.13l-.02-.06c-.06.04-.13.07-.21.07-.13,0-.21-.08-.21-.23v-.23Z"
          />
          <path
            className="cls-1"
            d="M27.25,16.17h.21v-.03c0-.06-.02-.11-.1-.11s-.11.04-.11.11v.03ZM27.38,16.45c.06,0,.13-.01.2-.03l.03.13c-.08.03-.17.04-.25.04-.21,0-.28-.1-.28-.26v-.18c0-.14.06-.26.28-.26s.26.13.26.27v.14h-.37v.03c0,.08.03.11.13.11"
          />
          <path
            className="cls-1"
            d="M28.17,16.57v-.47s-.02-.05-.05-.05c-.04,0-.12.02-.18.06v.47h-.17v-.67h.13l.02.06c.08-.04.19-.07.27-.07.06,0,.11.03.13.07.08-.04.19-.07.27-.07.11,0,.15.08.15.2v.49h-.17v-.47s-.02-.05-.05-.05c-.04,0-.12.03-.18.06v.47h-.17Z"
          />
          <path
            className="cls-1"
            d="M28.92,15.9h.17v.67h-.17v-.67ZM28.92,15.61h.17v.19h-.17v-.19Z"
          />
          <path
            className="cls-1"
            d="M29.49,16.58c-.07,0-.17-.02-.23-.04l.02-.13c.06.02.13.03.2.03.07,0,.08-.02.08-.07,0-.04,0-.06-.12-.09-.16-.04-.18-.08-.18-.21s.06-.19.25-.19c.06,0,.14,0,.2.02l-.02.13c-.05-.01-.13-.02-.18-.02-.07,0-.08.02-.08.06,0,.05,0,.06.09.08.19.05.21.07.21.21,0,.13-.04.21-.24.21"
          />
          <path
            className="cls-1"
            d="M29.9,15.9h.17v.67h-.17v-.67ZM29.9,15.61h.17v.19h-.17v-.19Z"
          />
          <path
            className="cls-1"
            d="M14.44,8.6c0,.48-.39.87-.87.87s-.87-.39-.87-.87.39-.87.87-.87.87.39.87.87"
          />
          <path
            className="cls-1"
            d="M11.44,14.49v-6.75h-1.46v7.19c0,.9.73,1.63,1.63,1.63h1.1v-1.46h-.66c-.34,0-.61-.27-.61-.61"
          />
          <path
            className="cls-1"
            d="M13.14,12.12v4.54h1.46v-4.98c0-.9-.73-1.63-1.63-1.63h-1.1v1.46h.66c.34,0,.61.27.61.61"
          />
          <path
            className="cls-1"
            d="M16.49,12.01v2.99h1.46v-3.43c0-.9-.73-1.63-1.63-1.63h-1.1v1.46h.66c.34,0,.61.27.61.61"
          />
          <path
            className="cls-1"
            d="M19.09,12.01v2.99h1.46v-3.43c0-.9-.73-1.63-1.63-1.63h-1.1v1.46h.66c.34,0,.61.27.61.61"
          />
          <path
            className="cls-1"
            d="M21.7,12.01v2.99h1.46v-3.43c0-.9-.73-1.63-1.63-1.63h-1.1v1.46h.66c.34,0,.61.27.61.61"
          />
          <path
            className="cls-1"
            d="M29.21,12.94v-2.99h-1.31v3.43c0,.9.73,1.63,1.63,1.63h.64v-1.46h-.35c-.34,0-.61-.27-.61-.61"
          />
          <path
            className="cls-1"
            d="M26.59,13.78c-.72,0-1.3-.58-1.3-1.3s.58-1.3,1.3-1.3,1.3.58,1.3,1.3-.58,1.3-1.3,1.3M26.59,9.95c-1.4,0-2.53,1.13-2.53,2.53s1.13,2.53,2.53,2.53,2.53-1.13,2.53-2.53-1.13-2.53-2.53-2.53"
          />
        </g>
      </g>
    </svg>
  </a>
);
